import {
    SET_PRODUCTSGUIDE,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
    CLEAR_PRODUCTS_GUIDE,
    VALIDATE_PRODUCTS,
    CLEAR_VALIDATED_PRODUCTS,
    GET_PRODUCTSGUIDE,
    GET_PRODUCT_DETAILS,
    SORT_PRODUCT_DETAILS,
    UPDATE_CART_DATA,
    UPDATE_CART_PRODUCTS_QUANTITY,
    CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT,
    SET_CART_DATA,
    SET_CART_DATA_PRICE_OVERRIDE,
    GET_PRODUCTS,
    GET_PRODUCTSTEMPLATESFILTER,
    SET_PRODUCTSTEMPLATESFILTER,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST,
    GET_TEMPLATE_DETAILS,
    CREATE_PRODUCT_TEMPLATE,
    RESET_CREATE_TEMPLATE,
    UPDATE_PRODUCT_TEMPLATE,
    GET_DATA_FOR_PRODUCT_TEMPLATE,
    SET_EXPANDED_FILTER_VIEW,
    SET_PROGRESS_BAR_STATUS,
    RESET_PROGRESS_BAR_STATUS,
    SET_PROGRESS_BAR_CURRENT_STEP,
    SET_PROGRESS_BAR_EDIT_MODE,
    GET_PRICES_FOR_ITEMS,
    RESET_PRICES_FOR_ITEMS,
    STORE_EQUITY_DETAILS,
    RESET_CART_DATA,
    STORE_ITEM_TABLE_DATA,
    UPDATE_CART_DATA_PRICEOVERRIDE,
    EQUITY_USAGE_ATTACHMENT_UPLOAD,
    EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
    EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
    EQUITY_DELETE_ATTACHMENT_REQUEST,
    EQUITY_RESET_PO_ATTACHMENT,
    EQUITY_GET_IMAGE_PO_PREVIEW,
    RESET_EQUITY_REFERENCE,
    INITIAL_EQUITY_DATA,
    SET_ORDER_FROM_REPORT_USAGE,
    EQUITY_ORDER_FROM_USAGE_DETAILS,
    GET_DROPDOWN_OPTIONS,
    SET_EQUITY_CU_IN_PROGRESS,
    SET_EQUITY_ORDER_SUBMITTED,
    RESET_CREATE_EQUITY,
    UPDATE_PRODUCT_TEMPLATE_LIST,
    RESET_DERIVED_TERRITORIES,
    STORE_SELECTED_PRODUCTS_DATA,
    RESET_STORE_ITEM_TABLE_DATA,
    SET_PRODUCT_TEMPLATE_UID,
    GET_PRODUCT_BUNDLE,
    CLEAR_TEMPLATE_PRODUCTS,
    SET_PRICES_FOR_ITEMS,
    SET_CART_LODER, 
} from './actionTypes';
export const SET_SURGERY_DETAILS = 'EQUITY: SET_SURGERY_DETAILS';
export const UPDATE_CART_DATA_SHIPPING = 'EQUITY: UPDATE_CART_DATA_SHIPPING';
export const SET_SHIPPING_DETAILS = 'EQUITY: SET_SHIPPING_DETAILS';
export const RESET_SHIPPING_DETAILS = 'EQUITY: RESET_SHIPPING_DETAILS';
export const SET_SHIPPING_DETAILS_EDIT_MODE =
    'EQUITY: SET_SHIPPING_DETAILS_EDIT_MODE';
export const GET_DROPDOWN = 'EQUITY: GET_DROPDOWN';
export const GET_DROPDOWN_SUCCESS = 'EQUITY: GET_DROPDOWN_SUCCESS';
export const GET_DROPDOWN_FAILURE = 'EQUITY: GET_DROPDOWN_FAILURE';
export const SAVE_SURGERY_DETAILS = 'SURGERY: SAVE_SURGERY_DETAILS';
export const SAVE_SURGERY_DETAILS_SUCCESS =
    'SURGERY: SAVE_SURGERY_DETAILS_SUCCESS';
export const SAVE_SURGERY_DETAILS_FAILURE =
    'SURGERY: SAVE_SURGERY_DETAILS_FAILURE';
export const UPDATE_SURGERY_DETAILS = 'SURGERY: UPDATE_SURGERY_DETAILS';
export const UPDATE_SURGERY_DETAILS_SUCCESS =
    'SURGERY: UPDATE_SURGERY_DETAILS_SUCCESS';
export const UPDATE_SURGERY_DETAILS_FAILURE =
    'SURGERY: UPDATE_SURGERY_DETAILS_FAILURE';

//export const GET_PRODUCTS = 'EQUITYPRODUCTS:GET_PRODUCTS';
//export const GET_PRODUCTS_SUCCESS = 'EQUITYPRODUCTS:GET_PRODUCTS_SUCCESS';
//export const GET_PRODUCTS_FAILURE = 'EQUITYPRODUCTS:GET_PRODUCTS_FAILURE';
export const GET_PRODUCTS_BULK = 'EQUITYPRODUCTS:GET_PRODUCTS_BULK';
export const GET_PRODUCTS_BULK_SUCCESS =
    'EQUITYPRODUCTS:GET_PRODUCTS_BULK_SUCCESS';
export const GET_PRODUCTS_BULK_FAILURE =
    'EQUITYPRODUCTS:GET_PRODUCTS_BULK_FAILURE';
export const SET_PRODUCTS = 'EQUITYPRODUCTS:SET_PRODUCTS';
export const CLEAR_PRODUCTS = 'EQUITYPRODUCTS:CLEAR_PRODUCTS';

export const SET_PRICING_NOTES = 'SET_PRICING_NOTES';

export const GET_SHIPPING_METHODS = 'EQUITYSHIPPING: GET_SHIPPING_METHODS';
export const GET_SHIPPING_METHODS_SUCCESS =
    'EQUITYSHIPPING: GET_SHIPPING_METHODS_SUCCESS';
export const GET_SHIPPING_METHODS_FAILURE =
    'EQUITYSHIPPING: GET_SHIPPING_METHODS_FAILURE';
export const GET_SHIP_TO_ADDRESS = 'EQUITYSHIPPING: GET_SHIP_TO_ADDRESS';
export const GET_SHIP_TO_ADDRESS_RESET =
    'EQUITYSHIPPING: GET_SHIP_TO_ADDRESS_RESET';
export const GET_SHIP_TO_SEARCH_SUCCESS =
    'EQUITYSHIPPING: GET_SHIP_TO_SEARCH_SUCCESS';
export const GET_SHIP_TO_SEARCH_SUCCESS_TISSUE =
    'EQUITYSHIPPING: GET_SHIP_TO_SEARCH_SUCCESS_TISSUE';
export const GET_SHIP_TO_ADDRESS_SUCCESS =
    'EQUITYSHIPPING: GET_SHIP_TO_ADDRESS_SUCCESS';
export const GET_SHIP_TO_ADDRESS_FAILURE =
    'EQUITYSHIPPING: GET_SHIP_TO_ADDRESS_FAILURE';
export const GET_BATCH_ALLOCATIONS = 'SHIPPING: GET_BATCH_ALLOCATIONS';
export const GET_BATCH_ALLOCATIONS_SUCCESS =
    'SHIPPING: GET_BATCH_ALLOCATIONS_SUCCESS';
export const GET_BATCH_ALLOCATIONS_FAILURE =
    'SHIPPING: GET_BATCH_ALLOCATIONS_FAILURE';

export const SET_VISUALIZATION_INSPECTION =
    'SUBMIT: SET_VISUALIZATION_INSPECTION';
//Surgery Notes
export const HANDLE_SURGERY_NOTES = 'HANDLE_SURGERY_NOTES';
export const GET_SURGERY_DETAILS = 'EQUITY:GET_SURGERY_DETAILS';
export const GET_SURGERY_DETAILS_SUCCESS = 'EQUITY:GET_SURGERY_DETAILS_SUCCESS';
export const GET_SURGERY_DETAILS_FAILURE = 'EQUITY:GET_SURGERY_DETAILS_FAILURE';
export const RESET_EQUITY_DETAILS = 'RESET_EQUITY_DETAILS';
export const RESET_EQUITY_DETAILS_DATA = 'EQUITY: RESET_EQUITY_DETAILS_DATA';
export const CHANGE_SHIPPING_SEGMENT_INDEX = 'CHANGE_SHIPPING_SEGMENT_INDEX';

export const DISABLE_SURGERY_DATE = 'DISABLE_SURGERY_DATE';
export const CURRENT_SURGERY_DATE_SELECTED = 'CURRENT_SURGERY_DATE_SELECTED';
export const CHANGE_ACKNOWLEGMENT_VIEW = 'EQUITY:CHANGE_ACKNOWLEGMENT_VIEW';

export const SET_UNSAVED_CHANGES_POP_UP = 'EQUITY:SET_UNSAVED_CHANGES_POP_UP';

export const PHYSICIAN_LOAD_ALL_LOADING = 'PHYSICIAN_LOAD_ALL_LOADING';
export const SET_ROUTE_PATH_FOR_EQUITY_UNSAVED_CHANGES_POP_UP =
    'EQUITY:SET_ROUTE_PATH_FOR_EQUITY_UNSAVED_CHANGES_POP_UP';

//set recently used PhysicianS
export const PUT_RECENTLY_USED_PHYSICIANS = 'PUT_RECENTLY_USED_PHYSICIANS';
export const PUT_RECENTLY_USED_PHYSICIANS_SUCCESS =
    'PUT_RECENTLY_USED_PHYSICIANS_SUCCESS';
export const PUT_RECENTLY_USED_PHYSICIANS_FAILURE =
    'PUT_RECENTLY_USED_PHYSICIANS_FAILURE';

//get derived territories (non-interventional)
export const GET_DERIVED_TERRITORIES = 'EQUITY: GET_DERIVED_TERRITORIES';
export const SET_DERIVED_TERRITORIES_SUCCESS =
    'EQUITY: SET_DERIVED_TERRITORIES_SUCCESS';
export const SET_DERIVED_TERRITORIES_FAILURE =
    'EQUITY: SET_DERIVED_TERRITORIES_FAILURE';

export const CLEAR_SPECFIC_DROPDOWN_LIST =
    'EQUITY: CLEAR_SPECFIC_DROPDOWN_LIST';
export const GET_HOLIDAY_LIST = 'GET_HOLIDAY_LIST';
export const GET_HOLIDAY_LIST_SUCCESS = 'GET_HOLIDAY_LIST_SUCCESS';
export const SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS =
    'SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS';
export const GET_HOLIDAY_LIST_ERROR = 'GET_HOLIDAY_LIST_ERROR';
export const CLEAR_SHIPPING_ADDRESS = 'CLEAR_SHIPPING_ADDRESS';
export const RESET_CREATE_UPDATE_SURGERY = 'RESET_CREATE_UPDATE_SURGERY';
export const GET_EQUITY_DETAILS = 'EQUITY: GET_EQUITY_DETAILS';
export const GET_EQUITY_DETAILS_SUCCESS = 'EQUITY: GET_EQUITY_DETAILS_SUCCESS';
export const GET_EQUITY_DETAILS_FAILURE = 'EQUITY: GET_EQUITY_DETAILS_FAILURE';
export const SAVE_EQUITY_DETAILS = 'EQUITY: SAVE_EQUITY_DETAILS';
export const SAVE_EQUITY_DETAILS_SUCCESS =
    'EQUITY: SAVE_EQUITY_DETAILS_SUCCESS';
export const SAVE_EQUITY_DETAILS_FAILURE =
    'EQUITY: SAVE_EQUITY_DETAILS_FAILURE';
export const RESET_CREATE_UPDATE_EQUITY = 'RESET_CREATE_UPDATE_EQUITY';
export const UPDATE_EQUITY_DETAILS = 'EQUITY: UPDATE_EQUITY_DETAILS';
export const UPDATE_EQUITY_DETAILS_SUCCESS =
    'EQUITY: UPDATE_EQUITY_DETAILS_SUCCESS';
export const UPDATE_EQUITY_DETAILS_FAILURE =
    'EQUITY: UPDATE_EQUITY_DETAILS_FAILURE';
export const VALIDATE_ACCOUNT = 'BILLING: VALIDATE_ACCOUNT';
export const VALIDATE_ACCOUNT_SUCCESS = 'BILLING: VALIDATE_ACCOUNT_SUCCESS';
export const VALIDATE_ACCOUNT_FAILURE = 'BILLING: VALIDATE_ACCOUNT_FAILURE';
export const RESET_VALIDATE_ACCOUNT = 'BILLING_RESET_VALIDATE_ACCOUNT';
export const STORE_EQUITY_REFERENCE = 'EQUITY: STORE_EQUITY_REFERENCE';

export const setSurgeryDetails = (surgeryDetails) => {
    return {
        type: SET_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

//
export const saveSurgery = (surgeryDetails) => {
    return {
        type: SAVE_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

export const updateSurgery = (surgeryDetails) => {
    return {
        type: UPDATE_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

export const setCartData = (cartData) => {
    return {
        type: SET_CART_DATA,
        payload: cartData,
    };
};
export const setItemLoader = (cartData) => {
    return {
        type: SET_CART_LODER,
        payload: cartData,
    };
};

export const setCartDataForPriceOverride = (cartData) => {
    return {
        type: SET_CART_DATA_PRICE_OVERRIDE,
        payload: cartData,
    };
};

export const updateCartData = (
    operation,
    productKey,
    isSet,
    childProductKey
) => {
    return {
        type: UPDATE_CART_DATA,
        payload: { operation, productKey, isSet, childProductKey },
    };
};

export const updateCartProductsQuantity = (
    quantity,
    productKey,
    isSet,
    childProductKey
) => {
    return {
        type: UPDATE_CART_PRODUCTS_QUANTITY,
        payload: {
            quantity: quantity,
            productKey: productKey,
            isSet: isSet,
            childProductKey: childProductKey,
        },
    };
};

export const updateCartDataPriceOverride = (
    productDetails,
    overriddenReason,
    pricingNotes,
    overrideDiscount
) => {
    return {
        type: UPDATE_CART_DATA_PRICEOVERRIDE,
        payload: {
            products: productDetails,
            overriddenReason: overriddenReason,
            pricingNotes: pricingNotes,
            overrideDiscount: overrideDiscount,
        },
    };
};

// export const updateCartDataPriceOverrideOverAllDiscount = (
//     productDetails,
//     value
// ) => {
//     //nami
//     return {
//         type: UPDATE_CART_DATA_PRICEOVERRIDE_OVERALL_DISCOUNT,
//         payload: { productDetails, value },
//     };
// };

export const updateCartDataShipping = (newFields, productKeys) => {
    return {
        type: UPDATE_CART_DATA_SHIPPING,
        payload: { newFields, productKeys },
    };
};

export const setShippingDetails = (shippingDetails) => {
    return {
        type: SET_SHIPPING_DETAILS,
        payload: shippingDetails,
    };
};

export const resetShippingDetails = () => {
    return {
        type: RESET_SHIPPING_DETAILS,
    };
};

export const setShippingDetailsEditMode = (shippingDetails) => {
    return {
        type: SET_SHIPPING_DETAILS_EDIT_MODE,
        payload: shippingDetails,
    };
};

export const getDropdownValues = (dropDownDetails) => {
    return {
        type: GET_DROPDOWN,
        payload: dropDownDetails,
    };
};
export const setProductsGuide = (productsGuideList, name) => {
    return {
        type: SET_PRODUCTSGUIDE,
        payload: productsGuideList,
        name: name,
    };
};

export const searchProducts = (queryParam, isBundle) => {
    return {
        type: GET_PRODUCTS,
        payload: { queryParam: queryParam, isBundle: isBundle },
    };
};

export const searchProductsBulk = (cfns) => {
    return {
        type: GET_PRODUCTS_BULK,
        payload: cfns,
    };
};

export const clearProducts = () => {
    return {
        type: CLEAR_PRODUCTS,
    };
};

export const getProductsGuide = () => {
    return {
        type: GET_PRODUCTSGUIDE,
    };
};

export const sortProductDetails = (data) => {
    return {
        type: SORT_PRODUCT_DETAILS,
        payload: data,
    };
};
export const setProgressBarStatus = (completedStep) => {
    return {
        type: SET_PROGRESS_BAR_STATUS,
        payload: completedStep,
    };
};

export const reSetProgressBarStatus = () => {
    return {
        type: RESET_PROGRESS_BAR_STATUS,
    };
};

export const setProgressBarCurrentStep = (currentStep) => {
    return {
        type: SET_PROGRESS_BAR_CURRENT_STEP,
        payload: currentStep,
    };
};

export const setProgressBarStateEditMode = (data) => {
    return {
        type: SET_PROGRESS_BAR_EDIT_MODE,
        payload: data,
    };
};

export const validateProducts = (products) => {
    return {
        type: VALIDATE_PRODUCTS,
        payload: products,
    };
};

export const clearValidatedProducts = () => {
    return {
        type: CLEAR_VALIDATED_PRODUCTS,
    };
};

export const getProductDetails = (data) => {
    return {
        type: GET_PRODUCT_DETAILS,
        payload: data,
    };
};

export const getProductsTemplatesFilter = () => {
    return {
        type: GET_PRODUCTSTEMPLATESFILTER,
    };
};

export const setProductsTemplatesFilter = (productsTemplatesFilter) => {
    return {
        type: SET_PRODUCTSTEMPLATESFILTER,
        payload: productsTemplatesFilter,
    };
};

export const getShippingMethods = (payload) => {
    return {
        type: GET_SHIPPING_METHODS,
        payload,
    };
};

export const getShipToAddress = (payload) => {
    return {
        type: GET_SHIP_TO_ADDRESS,
        payload: payload,
    };
};

export const getShippingBatchAllocations = (cfn) => {
    return {
        type: GET_BATCH_ALLOCATIONS,
        payload: cfn,
    };
};
export const handleSurgeryNotes = (data) => {
    return {
        type: HANDLE_SURGERY_NOTES,
        payload: data,
    };
};
export const setPricingNotes = (data) => {
    return {
        type: SET_PRICING_NOTES,
        payload: data,
    };
};
export const setVisualizationInspection = (value) => {
    return {
        type: SET_VISUALIZATION_INSPECTION,
        payload: value,
    };
};
export const getSurgeryDetails = (
    myCaseRef,
    updateState,
    resourceType,
    isFromOrderHistory = false,
    isCopyFromSummary = false
) => {
    return {
        type: GET_SURGERY_DETAILS,
        payload: {
            myCaseRef,
            updateState,
            resourceType,
            isFromOrderHistory,
            isCopyFromSummary,
        },
    };
};
export const resetEquityDetails = () => {
    return {
        type: RESET_EQUITY_DETAILS_DATA,
        payload: '',
    };
};
export const changeShippingSegmentIndex = (index) => {
    return {
        type: CHANGE_SHIPPING_SEGMENT_INDEX,
        payload: index,
    };
};
export const changeAcknowlegmentCheckbox = (data) => {
    return {
        type: CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT,
        payload: data,
    };
};
export const changeAcknowlegmentView = (data) => {
    return {
        type: CHANGE_ACKNOWLEGMENT_VIEW,
        payload: data,
    };
};
export const disableSurgeryDate = (value) => {
    return {
        type: DISABLE_SURGERY_DATE,
        payload: value,
    };
};
export const currentSurgeryDateSelected = (value) => {
    return {
        type: CURRENT_SURGERY_DATE_SELECTED,
        payload: value,
    };
};

export const getProductsCategoryAndBrands = (data) => {
    return {
        type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
        payload: data,
    };
};

export const getProductsByBrandOrSuperCategory = (data) => {
    return {
        type: GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
        payload: data,
    };
};

export const setEquityUnsavedChangesPopUp = (value) => {
    return {
        type: SET_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};
export const setEquityCUInProgress = (value) => {
    return {
        type: SET_EQUITY_CU_IN_PROGRESS,
        payload: value,
    };
};
export const loadAllPhyscianLoading = (data) => {
    return {
        type: PHYSICIAN_LOAD_ALL_LOADING,
        payload: data,
    };
};
export const putRecentlyUsedPhysicians = () => {
    return {
        type: PUT_RECENTLY_USED_PHYSICIANS,
    };
};
export const setRoutePathForEquityUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_EQUITY_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const getDerivedTerritories = (value) => {
    return {
        type: GET_DERIVED_TERRITORIES,
        payload: value,
    };
};

export const getDetailedProductTemplateList = (params) => {
    return {
        type: GET_DETAILED_PRODUCT_TEMPLATE_LIST,
        payload: params,
    };
};

export const getEquityTemplateDetails = (params) => {
    return {
        type: GET_TEMPLATE_DETAILS,
        payload: params,
    };
};

export const createTemplate = (params) => {
    return {
        type: CREATE_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const resetCreateTemplate = () => {
    return {
        type: RESET_CREATE_TEMPLATE,
    };
};

export const updateDetailedEquityProductTemplateList = (params) => ({
    type: UPDATE_PRODUCT_TEMPLATE_LIST,
    payload: params,
});

export const updateEquityProductTemplate = (params) => {
    return {
        type: UPDATE_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const getRequiredDataFromOrder = (params) => {
    return {
        type: GET_DATA_FOR_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const clearSingleDropDownList = (value) => {
    return {
        type: CLEAR_SPECFIC_DROPDOWN_LIST,
        payload: value,
    };
};
export const getHolidayList = (data) => {
    return {
        type: GET_HOLIDAY_LIST,
        payload: data,
    };
};
export const clearShippingAddress = (data) => {
    return {
        type: CLEAR_SHIPPING_ADDRESS,
        payload: data,
    };
};
export const resetCreateOrUpdateSurgery = () => {
    return {
        type: RESET_CREATE_UPDATE_SURGERY,
    };
};
export const resetCreateEquity = () => {
    return {
        type: RESET_CREATE_EQUITY,
    };
};
export const resetCreateUpdateEquity = () => {
    return {
        type: RESET_CREATE_UPDATE_EQUITY,
    };
};
export const resetShipToAddress = () => {
    return {
        type: GET_SHIP_TO_ADDRESS_RESET,
    };
};

export const setExpandedFilters = (data) => {
    return {
        type: SET_EXPANDED_FILTER_VIEW,
        payload: data,
    };
};

export const clearProductsGuide = () => {
    return {
        type: CLEAR_PRODUCTS_GUIDE,
    };
};

export const getEquityDetails = (params) => {
    return {
        type: GET_EQUITY_DETAILS,
        payload: params,
    };
};

export const saveEquity = (equityDetails) => {
    return {
        type: SAVE_EQUITY_DETAILS,
        payload: equityDetails,
    };
};

export const updateEquity = (equityDetails) => {
    return {
        type: UPDATE_EQUITY_DETAILS,
        payload: equityDetails,
    };
};

export const getValidateAccountDetails = (params) => {
    return {
        type: VALIDATE_ACCOUNT,
        payload: params,
    };
};

export const resetValidateAccountDetails = () => {
    return {
        type: RESET_VALIDATE_ACCOUNT,
    };
};

export const getPricesForItems = (priceItemsObj) => ({
    type: GET_PRICES_FOR_ITEMS,
    payload: priceItemsObj,
});
export const setPricesForItems = (priceItemsObj) => ({
    type: SET_PRICES_FOR_ITEMS,
    payload: priceItemsObj,
});

export const resetPricesForItems = () => ({
    type: RESET_PRICES_FOR_ITEMS,
});

export const storeSurgeryDetails = (equityData) => ({
    type: STORE_EQUITY_DETAILS,
    payload: equityData,
});

export const resetCartData = () => {
    return {
        type: RESET_CART_DATA,
    };
};

export const storeItemTableData = (itemTableData) => {
    return {
        type: STORE_ITEM_TABLE_DATA,
        payload: itemTableData,
    };
};

//ADD PO
export const usageAttachmentUpload = (formData) => ({
    type: EQUITY_USAGE_ATTACHMENT_UPLOAD,
    payload: formData,
});

export const getPoImagePreview = (details) => {
    return {
        type: EQUITY_GET_IMAGE_PO_PREVIEW,
        payload: details,
    };
};

export const resetPoDetails = () => ({
    type: EQUITY_RESET_PO_ATTACHMENT,
    payload: '',
});

export const setPOTissueImageDetails = (data) => {
    return {
        type: EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
        payload: data,
    };
};

export const setPONonTissueImageDetails = (data) => {
    return {
        type: EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
        payload: data,
    };
};

export const deleteAttachmentRequest = (id) => ({
    type: EQUITY_DELETE_ATTACHMENT_REQUEST,
    payload: id,
});

export const storeEquityReference = (equityData) => ({
    type: STORE_EQUITY_REFERENCE,
    payload: equityData,
});

export const resetEquityReference = () => ({
    type: RESET_EQUITY_REFERENCE,
});

export const initialEquityData = () => ({
    type: INITIAL_EQUITY_DATA,
});

export const setOrderFromReportUsage = (isOrderFromReportUsage) => ({
    type: SET_ORDER_FROM_REPORT_USAGE,
    payload: isOrderFromReportUsage,
});
export const setEquityOrderFromUsage = (myCaseRef, resourceType) => ({
    type: EQUITY_ORDER_FROM_USAGE_DETAILS,
    payload: {
        myCaseRef: myCaseRef,
        resourceType: resourceType,
    },
});

export const getDropdownOptionsRequest = (dropdownType) => ({
    type: GET_DROPDOWN_OPTIONS,
    payload: dropdownType,
});

export const setEquityOrderSubmitted = (isSubmitted) => ({
    type: SET_EQUITY_ORDER_SUBMITTED,
    payload: isSubmitted,
});

export const resetDerivedTerritories = () => ({
    type: RESET_DERIVED_TERRITORIES,
});

export const storeSelectedProducts = (selectedProducts) => ({
    type: STORE_SELECTED_PRODUCTS_DATA,
    payload: selectedProducts,
});

export const resetStoreItemTableData = (data) => ({
    type: RESET_STORE_ITEM_TABLE_DATA,
    payload: data,
});

export const setProductTemplateUID = (data) => ({
    type: SET_PRODUCT_TEMPLATE_UID,
    payload: data,
});

export const resetEquityDropDownDetails = (data) => ({
    type: RESET_EQUITY_DETAILS,
    payload: data,
});

export const searchProductsBundle = (cfns) => {
    return {
        type: GET_PRODUCT_BUNDLE,
        payload: cfns,
    };
};

export const clearTemplateProducts = () => {
    return {
        type: CLEAR_TEMPLATE_PRODUCTS,
    };
};
